import { render, staticRenderFns } from "./FormBuilderReportTable.vue?vue&type=template&id=55d10a47&"
import script from "./FormBuilderReportTable.vue?vue&type=script&lang=js&"
export * from "./FormBuilderReportTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports